/**
 * FacilityPanel
 * 
 * @Author: Focci
 * @Date: 2024-11-19 17:22:08
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-19 17:22:08
 */

// import PropTypes from 'prop-types'
import CloseIcon from '@mui/icons-material/Close'
import { useMapState } from '@comp/mapbox'
import { useTranslations } from 'next-intl'
import { OverallLayerScoff } from '../OverallLayer'
import { FacilityBody } from '../../facility'

export default function FacilityPanel({ houseId }) {
  const th = useTranslations('house')
  const mps = useMapState()

  return (
    <OverallLayerScoff
      autoCloseTime={864000}
      title={th('surroundingDevice')} 
      bodyHeight={300}
      onClear={() => mps.valueSetter('facilityPanel', false)}
      ClearIcon={CloseIcon}
      wrapperClassName="w-full md:w-60"
    >
      <FacilityBody houseId={houseId} />
    </OverallLayerScoff>
  )
}

// FacilityPanel.propTypes = {
//   className: PropTypes.string,
// }
